import React from 'react';
import { Link } from 'react-router-dom';

const Dashboard = () => {
  const stats = [
    { title: 'Khóa học', value: '45', change: '+3%', color: 'bg-green-500' },
    { title: 'Giáo viên', value: '28', change: '+5%', color: 'bg-purple-500' },
    { title: 'Lịch học hôm nay', value: '12', change: '+1%', color: 'bg-yellow-500' },
    { title: 'Thông báo mới', value: '3', change: '+1', color: 'bg-blue-500' }
  ];

  const recentActivities = [
    { action: 'Thông báo mới được thêm', user: 'Admin', time: '10 phút trước' },
    { action: 'Khóa học mới được tạo', user: 'Admin', time: '30 phút trước' },
    { action: 'Giáo viên cập nhật lịch', user: 'Thầy Hùng', time: '1 giờ trước' }
  ];

  const upcomingClasses = [
    { subject: 'Toán học nâng cao', teacher: 'Thầy Tuấn', time: '14:00', students: 25 },
    { subject: 'Tiếng Anh cơ bản', teacher: 'Cô Hoa', time: '15:30', students: 18 },
    { subject: 'Vật lý', teacher: 'Thầy Nam', time: '16:00', students: 22 }
  ];

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Header */}
      <div className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex justify-between items-center py-4">
            <h1 className="text-2xl font-bold text-gray-900">Dashboard</h1>
            <div className="flex items-center space-x-4">
              <span className="text-gray-600">Xin chào, Admin</span>
              <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center text-white font-semibold">
                A
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Stats */}
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          {stats.map((stat, index) => (
            <div key={index} className="bg-white rounded-lg shadow p-6">
              <div className="flex items-center">
                <div className={`${stat.color} rounded-lg p-3 mr-4`}>
                  <div className="w-6 h-6 text-white">📊</div>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-600">{stat.title}</p>
                  <p className="text-2xl font-bold text-gray-900">{stat.value}</p>
                  <p className="text-sm text-green-600">{stat.change}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Recent Activities */}
          <div className="bg-white rounded-lg shadow">
            <div className="px-6 py-4 border-b">
              <h3 className="text-lg font-medium">Hoạt động gần đây</h3>
            </div>
            <div className="p-6 space-y-4">
              {recentActivities.map((activity, index) => (
                <div key={index} className="flex items-center space-x-3">
                  <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                  <div className="flex-1">
                    <p className="text-sm font-medium text-gray-900">{activity.action}</p>
                    <p className="text-sm text-gray-600">{activity.user}</p>
                  </div>
                  <span className="text-xs text-gray-500">{activity.time}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Upcoming Classes */}
          <div className="bg-white rounded-lg shadow">
            <div className="px-6 py-4 border-b">
              <h3 className="text-lg font-medium">Lớp học sắp tới</h3>
            </div>
            <div className="p-6 space-y-4">
              {upcomingClasses.map((classItem, index) => (
                <div key={index} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                  <div>
                    <p className="font-medium text-gray-900">{classItem.subject}</p>
                    <p className="text-sm text-gray-600">{classItem.teacher}</p>
                  </div>
                  <div className="text-right">
                    <p className="font-medium text-blue-600">{classItem.time}</p>
                    <p className="text-sm text-gray-600">{classItem.students} học viên</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Quick Actions */}
        <div className="mt-8 bg-white rounded-lg shadow">
          <div className="px-6 py-4 border-b">
            <h3 className="text-lg font-medium">Thao tác nhanh</h3>
          </div>
          <div className="p-6 grid grid-cols-2 md:grid-cols-4 gap-4">
            <Link to="/admin/courses" className="flex flex-col items-center p-4 bg-green-50 rounded-lg hover:bg-green-100">
              <div className="w-12 h-12 bg-green-500 rounded-lg flex items-center justify-center text-white text-xl mb-2">📚</div>
              <span className="text-sm font-medium">Quản lý khóa học</span>
            </Link>
            <Link to="/admin/teachers" className="flex flex-col items-center p-4 bg-purple-50 rounded-lg hover:bg-purple-100">
              <div className="w-12 h-12 bg-purple-500 rounded-lg flex items-center justify-center text-white text-xl mb-2">🎓</div>
              <span className="text-sm font-medium">Quản lý giáo viên</span>
            </Link>
            <Link to="/admin/schedule" className="flex flex-col items-center p-4 bg-yellow-50 rounded-lg hover:bg-yellow-100">
              <div className="w-12 h-12 bg-yellow-500 rounded-lg flex items-center justify-center text-white text-xl mb-2">🗓️</div>
              <span className="text-sm font-medium">Lịch học</span>
            </Link>
            <Link to="/admin/add-notification" className="flex flex-col items-center p-4 bg-blue-50 rounded-lg hover:bg-blue-100">
              <div className="w-12 h-12 bg-blue-500 rounded-lg flex items-center justify-center text-white text-xl mb-2">📝</div>
              <span className="text-sm font-medium">Thêm thông báo</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
